import { atom } from 'recoil';

export const toggleSspModels = atom({
    key: 's3-bucket-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isS3FolderOpen: false,
    },
});

export const isEnvDetailsLoading = atom({
    key: 's3-bucket-isEnvDetailsLoading',
    default: false,
});

export const orderId = atom({
    key: 's3-bucket-orderId',
    default: '',
});

export const sspSubmitOrder = atom({
    key: 's3-bucket-sspOrder',
    default: {
        // Application Section
        applicationName: null,
        appShortName: null,
        appProfile: null,
        entityDetails: null,
        sector: null,
        sectorDetails: null,
        department: null,
        appRegion: null,
        environment: null,
        landingZoneDetails: null,
        hCode: null,
        hCodeDetails: null,
        appOwner: null,
        appOwnerDetails: null,

        // Resource Section
        awsAccount: null,
        bucketName: null,
        storageClass: null,
        appSupportTeamName: null,
        serverSideEncryption: null,
        blockPublicAccess: 'no',
        versioning: 'no',
        s3BucketKeyEnabled: 'no',
        s3ObjectLockEnabled: 'no',
        isS3BucketFolderRequired: 'no',
        s3Folders: [],

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 's3-bucket-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 's3-bucket-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidProvisioningForm = atom({
    key: 's3-bucket-isValidProvisioningForm',
    default: false,
});

export const isAppNameValid = atom({
    key: 's3-bucket-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 's3-bucket-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 's3-bucket-isAppShortNameExist',
    default: false,
});
